import { render, staticRenderFns } from "./EditList.vue?vue&type=template&id=6acf5506&scoped=true&"
import script from "./EditList.vue?vue&type=script&lang=js&"
export * from "./EditList.vue?vue&type=script&lang=js&"
import style0 from "./EditList.vue?vue&type=style&index=0&id=6acf5506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acf5506",
  null
  
)

export default component.exports